import { Document, ExtractedData } from './types';

// ============================================================================
// Speed Configuration
// ============================================================================

/**
 * Global speed multiplier for the entire demo animation.
 * - Values < 1: Speed up the demo (e.g., 0.5 = 2x faster)
 * - Values > 1: Slow down the demo (e.g., 2 = 2x slower)
 * - Default: 2 (2x slower for better visibility)
 */
export const SPEED_MULTIPLIER = 2;

// ============================================================================
// Demo Configuration Factory
// ============================================================================

export const getDemoConfig = (fileName?: string, fileSize?: string) => ({
    // Source file details
    sourceFile: {
        name: fileName || 'Technical-Manual.pdf',
        size: fileSize || '12.4 MB',
    },

    // Documents discovered from source
    documents: [
        { id: 1, type: 'AD', pages: 2 },
        { id: 2, type: 'TC', pages: 138 },
        { id: 3, type: 'TC', pages: 149 },
        { id: 4, type: 'TC', pages: 150 },
        { id: 5, type: 'TC', pages: 149 },
    ] as Document[],

    // Extracted metadata for each document
    extractedData: [
        {
            id: 1,
            partNumber: '2012-0198R1',
            serial: 'AD',
            date: '10 October 2014',
        },
        {
            id: 2,
            partNumber: '320-M-SF-7G-SB-A320-28-1188-0-01',
            serial: 'TC',
            date: '28-Apr-2014',
        },
        {
            id: 3,
            partNumber: '320-M-SF-7G-SB-A320-28-1188-0-02',
            serial: 'TC',
            date: '28-Apr-2014',
        },
        {
            id: 4,
            partNumber: '320-M-SF-7G-SB-A320-28-1188-0-03',
            serial: 'TC',
            date: '28-Apr-2014',
        },
        {
            id: 5,
            partNumber: '320-M-SF-7G-SB-A320-28-1188-0-04',
            serial: 'TC',
            date: '28-Apr-2014',
        },
    ] as ExtractedData[],

    // Timing configuration (in milliseconds) - all values are multiplied by SPEED_MULTIPLIER
    timing: {
        uploadInterval: 40 * SPEED_MULTIPLIER, // How often to update upload progress
        uploadProgressStep: 2.5 / SPEED_MULTIPLIER, // How much to increment progress each interval (inverse for speed)
        uploadCompleteDelay: 2000, // Delay after upload before splitting starts
        stageTransitionDelay: 5000 * SPEED_MULTIPLIER, // Delay before switching from splitting to extracting stage

        // Per-document delays
        documents: [
            {
                splitDelay: 2000 * SPEED_MULTIPLIER,
                extractDelay: 4000 * SPEED_MULTIPLIER,
            }, // Document 1 (AD)
            {
                splitDelay: 4000 * SPEED_MULTIPLIER,
                extractDelay: 6000 * SPEED_MULTIPLIER,
            }, // Document 2 (TC)
            {
                splitDelay: 6000 * SPEED_MULTIPLIER,
                extractDelay: 8000 * SPEED_MULTIPLIER,
            }, // Document 3 (TC)
            {
                splitDelay: 8000 * SPEED_MULTIPLIER,
                extractDelay: 10000 * SPEED_MULTIPLIER,
            }, // Document 4 (TC)
            {
                splitDelay: 10000 * SPEED_MULTIPLIER,
                extractDelay: 12000 * SPEED_MULTIPLIER,
            }, // Document 5 (TC)
        ],
    },
});
